import React, { SetStateAction, useState, Dispatch, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { useHistory } from "react-router-dom";

import axios from 'axios'

import { COLORS } from '../Theme'

import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import { SNACKBAR_TIME, Values } from '../../request/values'

import { member as v_member, basic } from '../../request/values';
import { useCookies } from 'react-cookie';

import useCommonStyles from '../commonStyles/headerEmpty/useCommonStyles';

const SERVER = basic.server;


const useStyles = makeStyles((theme) => ({
    background: {
        top: 0,
        width: '100%',
        height: '100%',
        background: `url("/images/background.png")`,
    },
    wrapper: {
      padding: '9vh 0',
      [theme.breakpoints.up("md")]: {
        padding: '0',
        },
     },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WATER_BLUE}`,
        textColor: '#ffffff',
    },
    logoSection: {
        position: 'absolute',
        bottom: '5vh',
        width: '100vw',
        textAlign: 'center'
    },
}));

type PersonalInfoParams = {
    email: string;
    password: string;
};

const PersonalInfo: React.FC<any> = props => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    let history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies();
    const state: any = history.location.state
    const { email, password } = state;

    const { member, setMember, token } = props
    const [name, setName] = useState<string>('');
    const [phone, setPhone] = useState<string>('');

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;

        if (id == 'name') setName(value);
        else setPhone(value);
    }

    const action = (key: any) => (
        <Fragment>
            <Button onClick={() => { closeSnackbar(key) }}>
                Close
            </Button>
        </Fragment>
    );

    const checkData = () => {
        if (name.length < 2 || name.length > 10) {
            enqueueSnackbar(ToastStr.NAME_ET_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            return false;
        }
        if (phone.length != 11) {
            enqueueSnackbar(ToastStr.PHONE_ET_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            return false;
        }
        console.log('check true')
        return true;
    }

    const handleButton = (event: any) => {
        // event.preventDefault();

        // console.log(email, password)

        if (!checkData()) {
            console.log('check false')
            return;
        }


        axios({
            method: "POST",
            data: {
                name: name,
                phone: phone,
                email: email,
                pwd: password,
                token: token,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.join,
        })
            .then((res) => {
                return res.data
            }).then((data: any) => {
                console.log(data)
                if (data.code == Values.SUCCESS_CODE) {
                    setMember({ id: email, name: name })
                    setCookie('access', data.jwt)
                    axios.defaults.headers.common['Authorization'] = `Bearer ${data.jwt}`;
                    history.push({
                        pathname: '/',
                    });
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.JOIN_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    }
                }
            })
    }

    return (
        <div className={classes.background}>
          <div className={classes.wrapper}>
                <div className={commonClasses.paper}>
                  <div className={commonClasses.titleLeft}>
                            플레이 스타트업에
                            <br />
                            오신 것을 환영합니다!
                    </div>

                    <div className={commonClasses.form}>
                        <TextField
                            variant="standard"
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            label="이름을 입력하세요."
                            name="name"
                            autoComplete="name"
                            autoFocus
                            InputProps={{ className: commonClasses.passwordInputProps }}
                            InputLabelProps={{ className: commonClasses.inputLabel }}
                            value={name}
                            onChange={valueChangeHandler}
                            style={{ color: `${COLORS.charcoal_grey}` }}
                        />
                        <TextField
                            variant="standard"
                            margin="normal"
                            required
                            fullWidth
                            name="phone"
                            label="휴대폰 번호를 입력하세요. (ex 01012341234)"
                            id="phone"
                            autoComplete="phone"
                            InputProps={{ className: commonClasses.passwordInputProps }}
                            InputLabelProps={{ className: commonClasses.inputLabel }}
                            value={phone}
                            onChange={valueChangeHandler}
                            style={{ color: `${COLORS.charcoal_grey}` }}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className={classes.submit}
                            onClick={handleButton}
                        >
                            <Typography variant="h3">
                                플레이 스타트업 시작하기
                            </Typography>
                        </Button>
                    </div>
                </div>
                </div>      
        </div>


    );
}

export default PersonalInfo;

// const useStyles = (theme: Theme) =>
//     createStyles({
//     paper: {
//         marginTop: theme.spacing(8),
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//     },
//     avatar: {
//         margin: theme.spacing(1),
//         backgroundColor: theme.palette.secondary.main,
//     },
//     form: {
//         width: '100%', // Fix IE 11 issue.
//         marginTop: theme.spacing(1),
//     },
//     submit: {
//         margin: theme.spacing(3, 0, 2),
//     },
// });

// interface SigInProps extends WithStyles<typeof useStyles> {
//     setMember: (m:iMember)=>void,
// }

// interface SignInState {
//     member_email: string | undefined | null,
//     member_password: string | undefined | null,
//     isLoggedIn: boolean | string,
// }

// class SignIn extends React.Component<SigInProps, SignInState> {
//     constructor(props: SigInProps) {
//         super(props);
//         this.state = {
//             member_email: undefined,
//             member_password: undefined,
//             isLoggedIn: false,
//         }

//         this.valueChangeHandler = this.valueChangeHandler.bind(this);
//         this.submitHandler = this.submitHandler.bind(this);
//     }

//     valueChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
//         const {id, value} = e.target;
//         let stateId:string = "member_" + id;

//         this.setState({ [id]: value } as Pick<SignInState, keyof SignInState>);
//     }

//     submitHandler = (event:any) => {
//         event.preventDefault();
//         const requestOption = {
//             method: 'POST',
//             headers: {
//                 "Content-Type": "application/json; charset=utf-8"
//             },
//             body: JSON.stringify({
//                 'email': this.state.member_email,
//                 'password': this.state.member_password
//             })
//         }
//         console.log('in submitHandler')
//         fetch('http://localhost:3001/v3/member/login', requestOption)
//             .then((res) => {
//                 return res.json()
//             }).then((data)=> {
//                 console.log(data)
//                 if (data.code == '9400') {
//                     alert('Login Failed!')
//                 } else {
//                     this.props.setMember(data.member);
//                     // this.setState({
//                     //     isLoggedIn: true,
//                     // })
//                 }
//             })
//     }

//     render() {
//         const { classes } = this.props;

//         return (
//             <Container component="main" maxWidth="xs">
//                 <CssBaseline />
//                 <div className={classes.paper}>
//                     <Avatar className={classes.avatar}>
//                         <LockOutlinedIcon />
//                     </Avatar>
//                     <Typography component="h1" variant="h5">
//                         Sign in
//                     </Typography>
//                     <form className={classes.form} onSubmit={this.submitHandler} noValidate>
//                         <TextField
//                             variant="outlined"
//                             margin="normal"
//                             required
//                             fullWidth
//                             id="member_email"
//                             label="Email Address"
//                             name="email"
//                             autoComplete="email"
//                             autoFocus
//                             value={this.state.member_email}
//                             onChange={this.valueChangeHandler}
//                         />
//                         <TextField
//                             variant="outlined"
//                             margin="normal"
//                             required
//                             fullWidth
//                             name="password"
//                             label="Password"
//                             type="password"
//                             id="member_password"
//                             autoComplete="current-password"
//                             value={this.state.member_password}
//                             onChange={this.valueChangeHandler}
//                         />
//                         <FormControlLabel
//                             control={<Checkbox value="remember" color="primary" />}
//                             label="Remember me"
//                         />
//                         <Button
//                             type="submit"
//                             fullWidth
//                             variant="contained"
//                             color="primary"
//                             className={classes.submit}
//                         >
//                             Sign In
//                         </Button>
//                         <Grid container>
//                             <Grid item xs>
//                                 <Link href="#" variant="body2">
//                                     Forgot password?
//                                 </Link>
//                             </Grid>
//                             <Grid item>
//                                 <Link href="#" variant="body2">
//                                     {"Don't have an account? Sign Up"}
//                                 </Link>
//                             </Grid>
//                         </Grid>
//                     </form>
//                 </div>
//                 <Box mt={8}>
//                     <Copyright />
//                 </Box>
//             </Container>
//         )
//     }
// }



// export default withStyles(useStyles)(SignIn);
// export default connect((isAuthUser => ({isAuthUser})))(withStyles(useStyles)(SignIn));


